import styled from 'styled-components'
import { themeColor } from '@elparking/components'

const mediaScreenMobile = props => `@media screen and (max-width: ${props.theme.screens.medium})`

export default styled.div`
    background: ${themeColor('lightGray20')};
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    height: 100%;
    scroll-behavior: smooth;
    margin-bottom: 27px;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.1);

    ${mediaScreenMobile} {
        width: 100%;
        position: relative;
        margin-bottom: 0;
    }
`
